import {
  createDvirEntry,
  bulkImportDvir,
  importDvirCsv,
  createFuelEntry,
  bulkImportFuel,
  importFuelCsv,
} from '@/services/api/maintenance/maintenance'

export default {
  namespaced: true,

  state: {
    submitting: false,
  },

  mutations: {
    SET_SUBMITTING(state, val) {
      state.submitting = val
    },
  },

  actions: {
    /* ── DVIR ── */
    async createDvir({ commit }, payload) {
      commit('SET_SUBMITTING', true)
      return createDvirEntry(payload)
        .then((res) => {
          commit(
            'notification/NEW',
            { type: 'success', message: 'DVIR Submitted', description: 'DVIR report submitted successfully.' },
            { root: true },
          )
          return res
        })
        .catch((error) => {
          const msg = error?.response?.data?.message
          commit(
            'notification/NEW',
            { type: 'error', message: 'Submit Error', description: Array.isArray(msg) ? msg.join('\n') : (msg || 'Failed to submit DVIR.') },
            { root: true },
          )
          throw error
        })
        .finally(() => commit('SET_SUBMITTING', false))
    },

    async createDvirBulk({ commit }, payload) {
      commit('SET_SUBMITTING', true)
      return bulkImportDvir(payload.entries)
        .then((res) => {
          commit(
            'notification/NEW',
            { type: 'success', message: 'DVIR Reports Saved', description: `${payload.entries.length} DVIR report(s) saved successfully.` },
            { root: true },
          )
          return res
        })
        .catch((error) => {
          const msg = error?.response?.data?.message
          commit(
            'notification/NEW',
            { type: 'error', message: 'Submit Error', description: Array.isArray(msg) ? msg.join('\n') : (msg || 'Failed to save DVIR entries.') },
            { root: true },
          )
          throw error
        })
        .finally(() => commit('SET_SUBMITTING', false))
    },

    async importDvirCsv({ commit }, formData) {
      commit('SET_SUBMITTING', true)
      return importDvirCsv(formData)
        .then((res) => {
          commit(
            'notification/NEW',
            { type: 'success', message: 'Import Successful', description: 'DVIR CSV imported successfully.' },
            { root: true },
          )
          return res
        })
        .catch((error) => {
          const msg = error?.response?.data?.message
          commit(
            'notification/NEW',
            { type: 'error', message: 'Import Error', description: Array.isArray(msg) ? msg.join('\n') : (msg || 'Failed to import DVIR CSV.') },
            { root: true },
          )
          throw error
        })
        .finally(() => commit('SET_SUBMITTING', false))
    },

    /* ── Fuel ── */
    async createFuelEntry({ commit }, payload) {
      commit('SET_SUBMITTING', true)
      return createFuelEntry(payload)
        .then((res) => {
          commit(
            'notification/NEW',
            { type: 'success', message: 'Fuel Entry Submitted', description: 'Fuel report submitted successfully.' },
            { root: true },
          )
          return res
        })
        .catch((error) => {
          const msg = error?.response?.data?.message
          commit(
            'notification/NEW',
            { type: 'error', message: 'Submit Error', description: Array.isArray(msg) ? msg.join('\n') : (msg || 'Failed to submit fuel entry.') },
            { root: true },
          )
          throw error
        })
        .finally(() => commit('SET_SUBMITTING', false))
    },

    async createFuelBulk({ commit }, payload) {
      commit('SET_SUBMITTING', true)
      return bulkImportFuel(payload.entries)
        .then((res) => {
          commit(
            'notification/NEW',
            { type: 'success', message: 'Fuel Entries Saved', description: `${payload.entries.length} fuel entry/entries saved successfully.` },
            { root: true },
          )
          return res
        })
        .catch((error) => {
          const msg = error?.response?.data?.message
          commit(
            'notification/NEW',
            { type: 'error', message: 'Submit Error', description: Array.isArray(msg) ? msg.join('\n') : (msg || 'Failed to save fuel entries.') },
            { root: true },
          )
          throw error
        })
        .finally(() => commit('SET_SUBMITTING', false))
    },

    async importFuelCsv({ commit }, formData) {
      commit('SET_SUBMITTING', true)
      return importFuelCsv(formData)
        .then((res) => {
          commit(
            'notification/NEW',
            { type: 'success', message: 'Import Successful', description: 'Fuel CSV imported successfully.' },
            { root: true },
          )
          return res
        })
        .catch((error) => {
          const msg = error?.response?.data?.message
          commit(
            'notification/NEW',
            { type: 'error', message: 'Import Error', description: Array.isArray(msg) ? msg.join('\n') : (msg || 'Failed to import fuel CSV.') },
            { root: true },
          )
          throw error
        })
        .finally(() => commit('SET_SUBMITTING', false))
    },
  },

  getters: {},
}
